import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import { css } from '@emotion/css';

var _templateObject;
var py9 = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding-top: 0.9rem;\n  padding-bottom: 0.9rem;\n"])));

export { py9 };
//# sourceMappingURL=styles.js.map
